$(document).ready(function () {
  $(".navbar-nav li.shop-accessories-menu .row .col-md-3:last-child a").prop(
    "target",
    "_blank"
  );
});

$(".btn-nav2").on("click tap", function (event) {
  event.stopPropagation();
  $(".nav-container2").toggleClass("showNav2 hideNav2").removeClass("hidden");
  $("body").toggleClass("on").removeClass("hideNav2");
  $(this).toggleClass("animated");
});
$(".nav-container2").on("click", function (event) {
  event.stopPropagation();
});
$("body:not('.nav-container2')").click(function () {
  $(".nav-container2").addClass("hideNav2");
  $(".nav-container2").removeClass("showNav2");
  $("body").removeClass("on");
});

fiximg();
jQuery(window).resize(function () {
  fiximg();
});
function fiximg() {
  var height = jQuery(".design-excellence").height();
  jQuery(".full-wd").css("height", height + "px");
}

$(".mb-menu").removeAttr("id");
$(".mb-menu").removeClass("collapse");
$("#menu-header-menu .mega-menu").prepend('<i class="fas pluse fa-plus"></i>');
$(".navbar-toggler,.mb-menu .flaticon-close").click(function () {
  if ($(".mb-menu").hasClass("slide-left2"))
    $(".mb-menu").removeClass("slide-left2");
  else $(".mb-menu").addClass("slide-left2");
});

$("#menu-header-menu li .fas").click(function () {
  if ($(this).parent().find(".sub-menu").hasClass("open")) {
    $(".sub-menu").removeClass("open");
    $(this).addClass("fa-plus").removeClass("fa-minus");
  } else {
    $(".sub-menu").removeClass("open");
    $("#menu-header-menu li .fas").addClass("fa-plus").removeClass("fa-minus");
    $(this).parent().find(".sub-menu").addClass("open");
    $(this).removeClass("fa-plus").addClass("fa-minus");
    $(this).closest(".sub-menu").addClass("open");
  }
});

$(document).ready(function () {
  $("#menu-header-menu li").hover(
    function () {
      $("#Navigation").addClass("active-header");
    },
    function () {
      $("#Navigation").removeClass("active-header");
    }
  );
});
$(function () {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});
function sticky_relocate() {
  var window_top = $(window).scrollTop();
  if (window_top > 10) {
    $("#Navigation").addClass("stick-header stick-inner-header");
  } else {
    $("#Navigation").removeClass("stick-header stick-inner-header");
  }
}
